import lightbox from 'lightbox2';
// import "lightbox2/dist/css/lightbox.css";

lightbox.option({
	'wrapAround': true,
	alwaysShowNavOnTouchDevices: true
});
